/*@flow*/
import type { Element } from 'react';
import React from 'react';

const prefixProtocol = (url) => (url.match(/^http/) ? url : `https://${url}`);

export default ({
  children,
  ...rest
}: {
  href: string,
  children?: React$Node,
}): Element<'a'> => (
  <a
    {...rest}
    href={prefixProtocol(rest.href)}
    target="_blank"
    rel="noopener noreferrer"
  >
    {children || <i className="fa fa-external-link-alt" />}
  </a>
);
